export default "__VITE_ASSET__SNujkWFa__"